import { render, staticRenderFns } from "./AtomPeriods.vue?vue&type=template&id=1dc286a1"
import script from "./AtomPeriods.vue?vue&type=script&lang=js"
export * from "./AtomPeriods.vue?vue&type=script&lang=js"
import style0 from "./AtomPeriods.vue?vue&type=style&index=0&id=1dc286a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports